import { render, staticRenderFns } from "./RateCategoryTable.vue?vue&type=template&id=2ded7a0b&scoped=true&"
import script from "./RateCategoryTable.vue?vue&type=script&lang=js&"
export * from "./RateCategoryTable.vue?vue&type=script&lang=js&"
import style0 from "./RateCategoryTable.vue?vue&type=style&index=0&id=2ded7a0b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ded7a0b",
  null
  
)

export default component.exports